import React, { useState, useRef, useEffect } from "react";
import { useUser } from "../../hooks/useUser";
import {
  DropdownContainer,
  NotificationIcon,
  DropdownList,
  DropdownHeader,
  ChangeItem,
  ChangeDate,
  ChangeText,
  EmptyState,
} from "./styles/MenuDesplegable.styles";
import { listaCambios } from "../../_services/listaCambios.service";

const ChangelogDropdown = ({ icon }) => {
  const user = useUser();
  const [isOpen, setIsOpen] = useState(false);
  const [hasUnread, setHasUnread] = useState(true);
  const [cambios, setCambios] = useState({ listado: [], leido: true });
  const dropdownRef = useRef(null);

  useEffect(() => {
    const getData = async () => {
      try {
        let res = await listaCambios.getLastCambios(user.dni);
        setCambios(res);
        // Actualizar hasUnread cuando lleguen los datos del backend
        setHasUnread(!res.leido);
      } catch (error) {
        console.error("Error fetching cambios:", error);
        setCambios({ listado: [], leido: true });
        setHasUnread(false);
      }
    };

    getData();
  }, [user.dni]);

  // // MOCK después ver como se busca en el back y que se guarda en la DB
  // const cambios = {
  //   listado: [
  //     {
  //       date: "2025-10-31",
  //       text: "Se agregó menú de cambios",
  //     },
  //     {
  //       date: "2025-10-20",
  //       text: "Fix sobre valores convenios",
  //     },
  //     {
  //       date: "2025-10-05",
  //       text: "Se creó usuario nuevo",
  //     },
  //     {
  //       date: "2025-09-22",
  //       text: "Cambios en el formato pdf del convenio",
  //     },
  //   ],
  //   leido: true,
  // };

  useEffect(() => {
    const handleClickOut = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    //setHasUnread(cambios.leido);
    document.addEventListener("mousedown", handleClickOut);
    return () => {
      document.removeEventListener("mousedown", handleClickOut);
    };
  }, []);

  const handleIconClick = () => {
    setIsOpen(!isOpen);
    if (hasUnread) {
      setHasUnread(false);
      listaCambios.updateLastRead(user.dni);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("es-ES", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <DropdownContainer ref={dropdownRef}>
      <NotificationIcon onClick={handleIconClick} hasUnread={hasUnread}>
        <img src={icon} alt="Menú" />
      </NotificationIcon>

      {isOpen && (
        <DropdownList>
          <DropdownHeader>Últimos Cambios</DropdownHeader>

          {cambios.listado.length > 0 ? (
            cambios.listado.map((cambio, index) => (
              <ChangeItem key={index}>
                <ChangeDate>{formatDate(cambio.date)}</ChangeDate>
                <ChangeText>{cambio.text}</ChangeText>
              </ChangeItem>
            ))
          ) : (
            <EmptyState>No hay cambios recientes para mostrar</EmptyState>
          )}
        </DropdownList>
      )}
    </DropdownContainer>
  );
};

export default ChangelogDropdown;

/*
Errores: Cuando entra y me viene desde el back leido en true no me muestra el puntito en la campana. Lo muestra y lo saca ver bien porque hace esto.
TODO:
  DB: 
    - En la DB en la tabla de log_registers, hacer una columna nueva que guarde la fecha del login anterior antes de escribir el nuevo login.
    - Crear una tabla de registros de cambios que tenga dos columnas, una con fecha y la otra con texto de la descripción del cambio. 
    Ver bien quien puede ver los cambios y que cambios. Esto puede tener el problema que haya cambios que no puedan leer ciertas personas, si es así hay que
    ver como se hace para que esto no pase.
  Back:
    - Con esa fecha anterior buscar en la tabla nueva de registros de cambios buscar y comparar con la fecha del login anterior al día
    si hay cambios igual o mayor a esa fecha, traer los útimos 5 cambios y poner hasUnread en false, sino devolver los úiltimos 5 cambios y hasUnread en true.
    Esto puede tener el problema de cuando actualiza la página con F5 puede que se vuelva a poner hasUnread en false, cuando esté hecho hay que probarlo.
*/